import { useEffect, useState } from 'react';
import { OrganizaciaFilterSearch } from '../../../../model/OrganizaciaFilterSearch';
import Organizacia from '../../../../model/ciselniky/Organizacia';
import { useClient } from '../../../../context/ClientStatusContext';
import { fetchOrganizacie } from '../../../../client/external/ciselniky/organizaciaClient';
import { ClientStatus } from '../../../../model/ClientStatus';

interface ReturnType {
  organizacie: Organizacia[];
  organizacieStatus: ClientStatus;
}

export default (
  searchParams: OrganizaciaFilterSearch,
): ReturnType => {
  const {
    nazov,
    legislativna,
    platna,
    limit,
    ldap,
    typ,
    ids,
    execute = true,
  } = searchParams;

  const [, setAction] = useState(0);
  const { wrapClient, status, data } = useClient(fetchOrganizacie);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
      return prevState;
    });

    const act = setTimeout(async () => {
      if (execute) {
        await wrapClient(typ, ids, ldap, nazov, legislativna, platna, limit);
      }
    }, 300);

    // @ts-ignore
    setAction(act);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nazov, limit, execute]);

  return {
    organizacie: data || [],
    organizacieStatus: status,
  };
};
